"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fallback = exports.root = void 0;

const root = () => ({
  height: 304,
  width: '100%'
});

exports.root = root;

const fallback = () => ({
  height: 160,
  width: '100%'
});

exports.fallback = fallback;
//# sourceMappingURL=PerformanceChart.style.js.map